import * as actions from '../../actions/actions'

const initialState = {
  corporates: [],
  error: null
}

export default function corporate(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_CORPORATES_SUCCESS:
      return fetchCorporatesSuccess(state, action)
    case actions.FETCH_CORPORATES_FAILURE:
      return fetchCorporatesFailure(state, action)
    case actions.ENABLE_CORPORATE_SUCCESS:
      return enableCorporateSuccess(state, action)
    case actions.ENABLE_CORPORATE_FAILURE:
      return enableCorporateFailure(state, action)
    case actions.DISABLE_CORPORATE_SUCCESS:
      return disableCorporateSuccess(state, action)
    case actions.DISABLE_CORPORATE_FAILURE:
      return disableCorporateFailure(state, action)
    case actions.DELETE_CORPORATE_SUCCESS:
      return deleteCorporateSuccess(state, action)
    case actions.DELETE_CORPORATE_FAILURE:
      return deleteCorporateFailure(state, action)
    default:
      return state
  }
}

const enableCorporateSuccess = (state, action) => {
  return {
    ...state,
    corporates: action.corporates
  }
}

const enableCorporateFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const disableCorporateSuccess = (state, action) => {
  return {
    ...state,
    corporates: action.corporates
  }
}

const disableCorporateFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const fetchCorporatesSuccess = (state, action) => {
  return {
    ...state,
    corporates: action.corporates
  }
}

const fetchCorporatesFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const deleteCorporateSuccess = (state, action) => {
  return {
    ...state,
    corporates: action.corporates
  }
}

const deleteCorporateFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}